module.exports = __webpack_public_path__ + "static/img/eureka_icon_3.ab7d7c19.png";